import styled from 'styled-components';

import colors from 'themes/Main';

const { darkBlue } = colors;

export const Text = styled.h1`
  display: block;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 700;
  color: ${darkBlue};
`;
